import * as pdfjs from 'pdfjs-dist/legacy/build/pdf.mjs';
import {PUBLIC_URL} from '../../config';

// Module-level pdf.js setup. Kept out of usePdfDocument so its tests can mock it, because Jest cannot run
// import.meta. usePdfDocument's import of wasmUrl is also what sets the worker path, so it must stay.

// The legacy build, because the modern one calls built-ins such as Map.prototype.getOrInsertComputed
// without a fallback, and Firefox 140 and Safari 18 do not have them.
pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/legacy/build/pdf.worker.mjs', import.meta.url).toString();

// Absolute, because the worker resolves it as well. scripts/copy-pdfjs-wasm.mjs puts the files there.
export const wasmUrl = new URL(`${PUBLIC_URL}pdfjs/${pdfjs.version}/wasm/`, window.location.href).href;
